module.exports = __webpack_public_path__ + "img/instagram.0e84d592.png";